import type { ProductPublicDto } from "@sticker-giant/sg-frontend-common";
import { ItemProductType } from "@sticker-giant/sg-frontend-common";

export function isFinishedGood(product: ProductPublicDto): boolean {
  return product.pricingProductType.sku === ItemProductType.FIN;
}
